export default __webpack_public_path__ + "static/media/test-series-icon.d43f78f9.svg";